var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { computed, ref } from "vue";
import { initRefs, updateRefs, useCallbacks } from "@/composables/datasetPermissions";
import { withPrefix } from "@/utils/redirect";
import DatasetPermissionsForm from "@/components/Dataset/DatasetPermissionsForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserDatasetPermissions',
    props: {
        userId: null
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const { managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions, simplePermissions, checked, } = initRefs();
        const inputsUrl = computed(() => {
            return `/api/users/${props.userId}/permissions/inputs`;
        });
        function init() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data } = yield axios.get(withPrefix(inputsUrl.value));
                updateRefs(data.inputs, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions);
                loading.value = false;
            });
        }
        const title = "Set Dataset Permissions for New Histories";
        const formConfig = computed(() => {
            return {
                title: title,
                id: "edit-preferences-permissions",
                description: "Grant others default access to newly created histories. Changes made here will only affect histories created after these settings have been stored.",
                url: inputsUrl.value,
                icon: "fa-users",
                submitTitle: "Save Permissions",
                redirect: "/user",
            };
        });
        function change(value) {
            return __awaiter(this, void 0, void 0, function* () {
                const managePermissionValue = managePermissions.value[0];
                let access = [];
                if (value) {
                    access = [managePermissionValue];
                }
                const formValue = {
                    DATASET_MANAGE_PERMISSIONS: [managePermissionValue],
                    DATASET_ACCESS: access,
                };
                axios.put(withPrefix(inputsUrl.value), formValue).then(onSuccess).catch(onError);
            });
        }
        const { onSuccess, onError } = useCallbacks(init);
        return { __sfc: true, props, loading, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions, simplePermissions, checked, inputsUrl, init, title, formConfig, change, onSuccess, onError, DatasetPermissionsForm };
    }
});
